import StretchedBlock from "../components/StretchedBlock";
import { Trans, useTranslation } from "react-i18next";

export default function FAQ({}) {
  return (
    <>
    <div style={{display: "flex", flexDirection: "column", gap: "20px", alignItems: "center"}}>
        <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
            <h4 className="FAQ-header">FAQ</h4>
            <span className="FAQ-sub-header"><Trans i18nKey="faq.header" /></span>
        </div>
        <div style={{display: "flex", flexDirection: "column", gap: "8px", alignItems: "center", width: "100%"}}>
            <StretchedBlock header={<Trans i18nKey="faq.first.question" />} text={<Trans i18nKey="faq.first.answer" />}/>
            <StretchedBlock header={<Trans i18nKey="faq.first.question" />} text={<Trans i18nKey="faq.first.answer" />}/>
            <StretchedBlock header={<Trans i18nKey="faq.first.question" />} text={<Trans i18nKey="faq.first.answer" />}/>
            <StretchedBlock header={<Trans i18nKey="faq.first.question" />} text={<Trans i18nKey="faq.first.answer" />}/>
            <StretchedBlock header={<Trans i18nKey="faq.first.question" />} text={<Trans i18nKey="faq.first.answer" />}/>
        </div>
    </div>
    </>
  );
}